<template>
	<div ref="cardDetailRef" class="material">
		<div class="material-title">
			{{ material.name }}
			<el-tooltip class="item" effect="dark" content="已签约独家，作品仅数字像素售卖" placement="top">
				<div class="material-exclusive" v-show="material.exclusive === 0">独家</div>
			</el-tooltip>
		</div>
		<div class="material-detail">
			<el-card class="material-content-card main-detail" shadow="never">
				<div class="detail-wrap">
					<!-- <div class="detail-head"> -->
					<!-- <div class="detail-head__title">
							<span>{{ material.name }}</span> -->
					<!-- <div class="mode"> 
							<span :class="modeDeep ? '' : 'active'" @click="handleChangeMode"><img src="@/assets/images/sun.png" alt=""></span>
							<span :class="modeDeep ? 'active' : ''" @click="handleChangeMode"><img src="@/assets/images/moon.png" alt=""></span>
							</div> -->
					<!-- </div> -->
					<!-- <div class="detail-head__extra">
						<div class="tag">
							<span class="tag-item" v-for="item in detail.classList" :key="item.id">
								#{{ item.name }}
							</span>
						</div> -->
					<!-- <div class="time">
							<i class="el-icon-aim"></i>&nbsp;&nbsp;{{
								material.createTime | getTime
							}}
						</div> -->
					<!-- </div> -->
					<div class="detail-content">
						<video
							v-if="material.videoUrl"
							:src="material.videoUrl"
							controls="controls"
							style="width: 100%"
							controlsList="nodownload"
						></video>
						<div v-if="material.content" oncontextmenu="return false;">
							<div ref="materialDetail" v-html="material.content"></div>
						</div>
					</div>
				</div>
			</el-card>
			<div style="width: 385px">
				<el-card class="material-content-card material-info" shadow="never" v-if="material.id">
				<div class="material-info-tab" v-if="material.price">
					<div class="material-info-tab-item" @click="activeTab = 0;payUrl = ''" :class="{active: activeTab === 0}">个人授权</div>
					<div class="material-info-tab-item" @click="activeTab = 1;payUrl = ''" :class="{active: activeTab === 1}">商用授权</div>
					<!-- <div class="material-info-tab-item" @click="activeTab = 2;payUrl = ''" :class="{active: activeTab === 2}">商用PLUS授权</div> -->
				</div>
					<!-- <div class="material-info-name">
						<div class="exclusive" v-if="material.exclusive === 0">独家</div>
						<div class="title">{{ material.name }}</div>
					</div> -->
					<div class="material-info-addition">
						<div class="material-info-addition-item">
							<span v-if="material.price">
								<!-- <span v-if="isPaid" class="material-info-price-tag paid"
									>已购买</span
								> -->
								<!-- <span v-else class="material-info-price-tag needPay">付费</span> -->
								<span class="material-info-price-tag price" v-if="activeTab === 0">{{ material.price }}<i class="price-unit">元</i></span>
								<span class="material-info-price-tag price" v-if="activeTab === 1">{{ material.enterprisePrice }}<i class="price-unit">元</i></span>
								<!-- <span class="material-info-price-tag price" v-if="activeTab === 2">{{ material.enterprisePlusPrice }}<i class="price-unit">元</i></span> -->
								<span class="material-info-price-tag origin-price" v-if="activeTab === 0 && material.scribingPrice">
									{{ material.scribingPrice }}<i class="price-unit">元</i>
								</span>
								<span class="material-info-price-tag origin-price" v-if="activeTab === 1 && material.scribingEnterprisePrice">
									{{ material.scribingEnterprisePrice }}<i class="price-unit">元</i>
								</span>
								<!-- <span class="material-info-price-tag origin-price" v-if="activeTab === 2 && material.scribingEnterprisePlusPrice">
									{{ material.scribingEnterprisePlusPrice }}<i class="price-unit">元</i>
								</span> -->
							</span>
							<span v-else class="material-info-price-tag free">免费</span>
						</div>
						<div
							class="material-info-addition-item"
							style="justify-content: flex-end"
						>
							<!-- <span style="color: #999">{{ material.downloads }}次下载</span> -->
							<span style="color: #999"></span>
						</div>
						<div
							class="material-info-addition-item"
							style="justify-content: flex-end"
						>
							<span :class="isCollect?'collected-con': 'collect-con'" @click="handleCollect">
								<svg-icon
									icon-class="collected"
									:class-name="isCollect?'collected': 'icon-collect-btn'"
								></svg-icon>
								{{
									isCollect ? `${material.collections || 0}人已收藏` : '未收藏'
								}}</span
							>
							<!-- <span class="share"><img src="@/assets/images/share.png" alt="分享" class="share-img">分享</span> -->
						</div>
					</div>
					<!-- <template v-if="payUrl">
						<div class="pay-content">
							<div class="pay-tips" v-if="payType === 'wechat'">
								<img src="@/assets/images/wx-pay.png" alt="weixinpay" width="36" />
								<span>请使用微信支付</span>
							</div>
							<div class="pay-tips ali" v-if="payType === 'alipay'">
								<img src="@/assets/images/ali.png" alt="weixinpay" width="36" />
								<span>请使用支付宝支付</span>
							</div>
							<img v-lazy="payUrl" class="material-image" />
							<div class="more-pay-way" @click="payUrl = ''">更多支付方式</div>
						</div>
					</template> -->
					<template>
						<div class="material-info-detail">
							<!-- <div class="material-info-detail-desc">{{ material.remark }}</div> -->
							<!-- <el-divider></el-divider> -->
							<div class="detail-info-item">
								<!-- <img src="../../../assets/images/icon-no.png" alt=""> -->
								编号：<label>{{ material.serialCode }}</label>
							</div>
							<div class="detail-info-item">
								<!-- <img src="../../../assets/images/icon-author.png" alt=""> -->
								作者：<label class="author" title="点击可查看该作者所有素材" @click="toAuthor(material.author)">{{ material.author }}</label>
							</div>
							<div class="detail-info-item">
								<!-- <img src="../../../assets/images/icon-category.png" alt=""> -->
								分类：<label>{{ material.categoryList | filterName(" / ") }}</label>
							</div>
							<div v-if="material.size" class="detail-info-item">
								<!-- <img src="../../../assets/images/icon-size.png" alt=""> -->
								尺寸：<label>{{ material.size || '1233*23444px'}}</label>
							</div>
							<div class="detail-info-item">
								<!-- <img src="../../../assets/images/icon-type.png" alt=""> -->
								格式：<label>{{ material.formatList | filterName(" / ") }}</label>
							</div>
							<div class="detail-info-item" v-if="material.versionRecommend">
								<!-- <img src="../../../assets/images/icon-version.png" alt=""> -->
								版本推荐：<label>{{ material.versionRecommend}}</label>
							</div>
							<div class="detail-info-item">
								<!-- <img src="../../../assets/images/icon-file-size.png" alt=""> -->
								体积：<label>{{ material.fileSize || "0kb" }}</label>
							</div>
							<div class="detail-info-item">
								<!-- <img src="../../../assets/images/icon-date.png" alt=""> -->
								上传时间：<label>{{ material.createTime }}</label>
							</div>
							<div class="detail-info-item">
								<!-- <img src="../../../assets/images/icon-date.png" alt=""> -->
								声明：<label>虚拟产品一经售出，概不退换</label>
							</div>
						</div>
						<div v-if="material.price && !isPaid">
							<el-button
								class="pay-btn"
								:class="{'disabled': buttonDisabled}"
								type="primary"
								block
								@click="toPay"
							>
								<!-- <img
									src="@/assets/images/pay.png"
									alt="购买"
									class="download-btn-img"
								/> -->
								<span style="vertical-align: top">&nbsp;{{ !buttonDisabled ? '立即下载': '暂不支持购买'}}</span>
							</el-button>
							<div class="ques-text" style="margin-top: 5px">
								下载方式为百度网盘，购买后自动获取网盘链接
							</div>
						</div>
						<template v-else-if="(material.price && isPaid) || left || material.price == 0"> 
							<div class="baidu-code">网盘提取码：{{(material.baiduUrl || '').slice(-4)}}</div>
							<el-button
								:class="'download-btn baidu'"
								type="primary"
								@click="handleDownLoad('baidu')"
							>
								<img
									src="@/assets/images/baidu.png"
									alt="下载"
									class="download-btn-img"
								/>
								<span style="vertical-align: top">&nbsp;百度网盘下载</span>
							</el-button>
							<el-button
								class="download-btn local"
								:loading="isLocaleDownLoading"
								v-if="material.source"
								@click="handleDownLoad"
							>
								<img
									src="@/assets/images/local.png"
									alt="下载"
									class="download-btn-img"
									
								/>
								<span style="vertical-align: top">&nbsp;本地下载</span>
							</el-button>
							<div class="download-question">
								如遇下载问题，请<span @mouseenter="showPop('showContract', true)" @mouseleave="showPop('showContract', false)">点此联系</span>
								<div class="service-modal" v-show="showContract">
									<img src="../../../assets/images/contract.png" alt="" />
									<div>
										<div class="service-modal-tit">
											素材下载遇到问题，请加企业微信
										</div>
										<div class="service-modal-info">
											购买素材后，下载失败、网盘下载不便，请添加企业微信，我将及时为你解决
										</div>
									</div>
								</div>
							</div>
						</template>
						<!-- <el-button v-else class="download-btn" :disabled="true" type="primary">
							<img
								src="@/assets/images/download.png"
								alt="下载"
								class="download-btn-img"
							/>
							<span style="vertical-align: top" v-if="userInfo && userInfo.id">&nbsp;今日下载次数已用完</span>
							<span style="vertical-align: top" v-else>&nbsp;请登录后获得下载次数</span>
						</el-button> -->

						<!-- <div class="download-tip" v-if="!material.price">
							<div>剩余下载次数：{{material.left || 0}}</div>
							<div>免费下载次数获取规则
								<el-popover
									placement="bottom"
									title=""
									width="200"
									trigger="hover">
									<div style="font-size: 12px;">
										1、每日登录可获得下载次数+2<br />
										2、次数可累积
									</div>
									<i slot="reference" class="el-icon-warning-outline"></i>
								</el-popover>
							</div>
						</div> -->
					</template>
					<!-- <div class="material-info-detail-tagInfo" v-if="!showPayWay">
						<el-divider>素材标签</el-divider>
						<div class="material-info-detail-tag">
							<el-tag
								v-for="(label, index) in material.labelList"
								type="info"
								:key="index"
								>#{{ label.name }}</el-tag
							>
						</div>
					</div> -->
					<!-- <div class="material-info-detail-payWay" v-if="showPayWay && !payUrl && !isPaid">
						<div class="pay-tit">
							请选择支付方式
						</div>
						<div class="pay-con">
							<div class="pay-item" @click="handleClickPay('wechat')">
								<img src="../../../assets/images/wechat_pay.png" class="pay-icon" alt="">
								<div>微信支付</div>
							</div>
							<div class="pay-item" @click="handleClickPay('alipay')">
								<img src="../../../assets/images/ali_pay.png" class="pay-icon" alt="">
								<div>支付宝支付</div>
							</div>
						</div>
						<div class="pay-tip">
							其他支付方式请<span class="more-pay-way" @mouseenter="showPop('showMorePayWay', true)" @mouseleave="showPop('showMorePayWay', false)">点此联系</span> <br/>
							支付后如未跳转，请刷新当前页面
							<div class="service-modal" v-show="showMorePayWay">
								<img src="../../../assets/images/contract.png" alt="" /> 
								<div>
									<div class="service-modal-tit">
										支付及发票服务，请加企业微信
									</div>
									<div class="service-modal-info">
										对公支付，发票开具，请扫码添加企业微信，我将及时为你服务
									</div>
								</div>
							</div>
						</div>
					</div> -->
				<div class="authorized" v-if="material.price">
					<div class="authorized-tit">
						<span>{{activeTab === 0 ? '个人' : '商用'}}授权范围</span>
							<div class="authorized-right">
								<template v-if="material.price && !isPaid" >
									<span class="authorized-active-default" @click="openAuthImg" >授权书范本</span>
									<span class="authorized-active-default" @click="showAuthTable = true" >授权区别</span>
									<span class="authorized-active-default" @mouseenter="showPop('showAuthorized', true)" @mouseleave="showPop('showAuthorized', false)" >其他咨询</span>
								</template>
								<span class="authorized-active" @mouseenter="showPop('showAuthorized', true)" @mouseleave="showPop('showAuthorized', false)" v-else>获取授权书</span>
							</div>
							<div class="service-modal" v-show="showAuthorized">
								<img src="../../../assets/images/contract.png" alt="" /> 
								<div v-if="material.price && !isPaid">
									<div class="service-modal-tit">
										有问题，请加企业微信
									</div>
									<div class="service-modal-info">
										咨询素材、授权书、发票相关问题，请添加企业微信，我将及时为你服务
									</div>
								</div>
								<div v-else>
									<div class="service-modal-tit">
										授权书开具，请加企业微信
									</div>
									<div class="service-modal-info">
										购买素材后，需开具授权书，请添加企业微信，我将及时为你开具。
									</div>
								</div>
							</div>
						</div>
						<div class="authorized-item" v-for="item in authorizedList[activeTab]" :key="item.id">
							<img src="../../../assets/images/auth-pass.svg" v-if="item.selected === 0" alt="">
							<img src="../../../assets/images/auth-reject.svg" v-else alt="">
							<div class="authorized-item-text" :title="item.content">{{item.content}}</div>
						</div>
					</div>
					<div class="bottom-info">
						使用限制：供稿人仅对作品中独创性部分享有权利。对含有的国旗、国徽等党政图案不享有权利，地图数据不享有权利，仅作为作品整体效果的示例展示及爱党爱国宣传，禁止商用。
					</div>
				</el-card>
				<!-- <div class="ques" :class="{'ques-other': showPayWay}" v-if="!payUrl && !showPayWay && !material.paid && material.price">
					<img src="@/assets/images/officialAccounts.png" alt="公众号" />
					<div class="ques-desc">
						<p class="ques-text">
							没有想要的素材？扫码添加小编微信，提交你的素材需求
						</p>
					</div>
				</div> -->
			</div>
		</div>
		<div class="bottom">
			<div class="bottom-tit">同类素材推荐</div>
			<div class="material-list">
				<div 
					class="material-list-item" 
					v-for="(item, index) in materialList" 
					:key="index">
					<MaterialCard 
						:material="item" 
						@set-material="setMaterial"
					/>
				</div>
			</div>
		</div>
		
		<img-dialog-show 
			ref="imgDialog" 
			:img-dialog-show.sync="imgDialogShow" 
			@closeOrg="imgDialogShow = false" 
			:img-url-arr="pictureList" 
			:img-index="index"/>

		<div class="pay-modal" v-if="showPayWay">
			<div class="pay-modal-con">
				<img class="modal-close" @click="closePayModal" src="../../../assets/images/close.png" alt="">
				<div class="modal-tit">{{payType | getPayTitle}}</div>
				<div class="pay-con" v-if="!payType">
					<div class="pay-icon" @click="handleClickPay('wechat')">
						<img src="../../../assets/images/wechat_pay.png" alt="">
						<div>微信支付</div>
					</div>
					<div class="pay-icon alipay"  @click="handleClickPay('alipay')">
						<img src="../../../assets/images/ali_pay.png" alt="">
						<div>支付宝支付</div>
					</div>
					<div class="pay-icon common"  @click="handleClickPay('common')">
						<img src="../../../assets/images/common.png" alt="">
						<div>对公支付</div>
					</div>
				</div>
				<div class="pay-qr" v-else>
					<img :src="payUrl" alt="">
				</div>
			</div>
		</div>
		<auth-table :visible.sync="showAuthTable" :tableData="authTable" />

	</div>
</template>

<script>
import { mapState } from "vuex";
import Clickoutside from "element-ui/src/utils/clickoutside";
import debounce from "lodash/debounce";
import ImgDialogShow from '@/components/ImgDialogShow';
import AuthTable from '@/views/components/AuthTable';
import MaterialCard from './MaterialCard';
import { openWindow, virtualDownLoad } from "@/utils/utils";
import moment from 'moment';
import {
	collectMaterial,
	cancelCollectMaterial,
	getMaterialDetail,
	getResemble,
	getAuthorizedList,
	downloadMaterial
} from "@/api/material";
import { getIsImage } from "@/api/findImage";
import { getPayUrl, getStatus } from "@/api/order";
// import {
// 	bindEvent
// } from '@/utils/websocket'

export default {
	inject: ["checkToken"],
	directives: { Clickoutside },
	components:{
		ImgDialogShow,
		MaterialCard,
		AuthTable
	},
	filters: {
		filterName(list, format) {
			return (list || []).map(item => item.name).join(format);
		},
		getPayTitle(payType) {
			let patTitle = '请选择支付方式'
			if (payType== 'wechat') {
				patTitle = "请使用微信支付"
			}
			if (payType== 'alipay') {
				patTitle = "请使用支付宝支付"
			}
			if (payType== 'common') {
				patTitle = "对公支付请添加企微对接"
			}
			return patTitle
		}
	},
	data() {
		return {
			payType:"",
			activeTab: 0,
			showPayWay: false,
			showContract: false,
			showAuthorized: false,
			showMorePayWay:false,
			showAuthTable:false,
			authTable: [],
			authorizedList: {
				0: [],
				1: [],
				2:[]
			},
			// // 当日可下载次数，默认1次
			left: 1,
			// // 当前网盘地址编号
			// no: 0,
			collectMethod: collectMaterial,
			cancelCollectMethod: cancelCollectMaterial,
			// 是否已收藏
			isCollect: false,
			// 是否正在下载
			isDownLoading: false,
			payUrl: null,
			material: {},
			imgDialogShow: false,
			index: 0,
			pictureList:[],
			materialList:[],
			isLocaleDownLoading: false,
		};
	},
	computed: {
		...mapState("user", ["userInfo"]),
		buttonDisabled() {
			let checkValue = this.material.hidden;
			if (this.activeTab === 1) {
				checkValue = this.material.enterpriseEmpower
			}
			if (this.activeTab === 2) {
				checkValue = this.material.enterprisePlusEmpower
			}

			if (this.material.hidden !== 0) {
				checkValue = this.material.hidden
			}
			
			return checkValue !== 0
		},
		isPaid() {
			let isPaid = this.material.paid
			
			if (this.activeTab === 1) {
				isPaid = this.material.enterprisePaid
			}
			if (this.activeTab === 2) {
				isPaid = this.material.enterprisePlusPaid
			}

			return isPaid
		}
	},
	watch: {
		material: {
			immediate: true,
			handler(newVal) {
				this.isVisible = newVal !== null;
				if (newVal) {
					this.isCollect = newVal.isCollected;
					newVal.left !== undefined && (this.left = newVal.left);
				}
			},
		},
		isVisible() {
			if (this.isVisible) {
				this.$nextTick(() => {
					this.$refs.cardDetailRef &&
						(this.$refs.cardDetailRef.oncontextmenu = () => false);
				});
			}
		},
	},
	async created() {
		try {
			const id = this.$route.params.id
			const { data } = await getIsImage(id)
			if (data === 2) {
				this.$router.replace(`/findImage/detail/${id}`)
				return
			}
			this.getDetail();
			this.getResembleList();
		} catch (error) {
			this.getDetail();
			this.getResembleList();
			console.log("error: ", error);
		}
	},
	mounted() {
		// const _this = this;
		// bindEvent('pay_result', (success) => {
		// 	_this.payUrl = '';
		// 	_this.material.paid = success
		// });
	},
	methods: {
		toPay(){
			if (this.buttonDisabled) return;
			if (!this.checkToken()) return ;
			this.showPayWay = true;
		},	
		handleImage(i) {
            this.imgDialogShow = true;
            this.index = i;
			this.$nextTick(() => {
				this.$refs.imgDialog.handleClickImgOrg()
			})
        },
		bindImage() {
			const certificateImg = document.getElementById('certificateImg');
			const imgEl = [...this.$refs.materialDetail.getElementsByTagName('img')];
			if (certificateImg) {
				imgEl.push(certificateImg)
			}
			this.pictureList = imgEl.map(item => {
				return {
					address: item.src
				}
			})
			imgEl.forEach((item,index) => {
				item.addEventListener('click',() =>{
					this.handleImage(index)
				})
			})
		},
		/**
		 * @description: 后获取素材详情
		 * @param {*}
		 * @return {*}
		 */
		async getDetail() {
			try {
				const { data: material } = await getMaterialDetail({
					id: this.$route.params.id,
				});
				material.createTime = moment(material.createTime).format('YYYY-MM-DD')
				this.material = material;
				window.document.title = this.material.name
				console.log("materialInfo", material);
				this.$nextTick(() => {
					this.bindImage()
				})
				this.getAuthorizedList()
			} catch (error) {
				console.log("error: ", error);
			}
		},

		async getAuthorizedList() {
			try {
				const { data } = await getAuthorizedList();

				this.authorizedList = data;
				console.log('data: ', data);
				const objKey = {}
				this.authTable = []
				const last_person_index = data['0'].length -1
				Object.values(data || {}).flat().forEach(item => {
					
					if (!objKey[item.content]) {
						this.authTable.push({
							content: item.content,
							selected: {
								[item.type]:item.selected
							}
						})
					} else {
						const index = this.authTable.findIndex(subItem => subItem.content === item.content)
						this.authTable[index].selected[item.type] = item.selected
					}
					objKey[item.content] = item.content
				})
				const last_table_index = this.authTable.length - 1
				this.authTable.splice(last_table_index, 0, this.authTable.splice(last_person_index, 1)[0]);
			} catch (error) {
				console.log("error: ", error);
			}
		},

		showPop(name,value) {
			this.showAuthorized = false;
			this.showContract = false;
			this.showMorePayWay = false;
			this[name] = value
		},

	openAuthImg() {
		const imgUrl = this.activeTab === 0 ? '/static/images/person.png' : '/static/images/company.png'
		window.open(imgUrl)
	},

		async getResembleList() {
			try {
				const { data: materialList } = await getResemble({
					id: this.$route.params.id,
				});
				this.materialList = materialList || [];
			} catch (error) {
				console.log("error: ", error);
			}
		},
		// 点击收藏
		handleCollect: debounce(function() {
			if (!this.checkToken()) return;

			this[this.isCollect ? "cancelCollectMethod" : "collectMethod"]({
				userId: this.userInfo.id,
				materialId: this.material.id,
			}).then(() => {
				this.$message.success(this.isCollect ? "已取消收藏" : "收藏成功");
				this.material.collections = this.isCollect ? this.material.collections -- : this.material.collections ++
				this.isCollect = !this.isCollect;

				this.material.isCollected = this.isCollected
			});
		}, 300),
		// 点击下载
		handleDownLoad(type) {
			if (!this.userInfo) {
				this.$router.push({name: 'Login'})
				return;
			}
			if(type == 'baidu') {
				window.open(this.material.baiduUrl)
				return
			}
			// window.open(`${location.origin}/TobDesign/api/material/local/download?materialId=${this.material.id}`, '_blank')
			if (this.isLocaleDownLoading) {
				this.$message.warning('正在下载哦，不要心急');
				return;
			}
			this.isLocaleDownLoading = true;
			downloadMaterial(this.material.id)
				.then(res => {
					this.isLocaleDownLoading = false;
					this.left--;
					virtualDownLoad(res.data);

					this.material.left = this.left
					this.material.downloads ++;
				})
				.catch(() => {
					this.isLocaleDownLoading = false;
				});
		},
		closePayModal(){
			if(this.payUrl) {
				this.payUrl=''
				this.payType = ''
			} else {
				this.showPayWay = false;
			}
		},
		// 点击购买
		handleClickPay(payType) {
			this.payType = payType
			if (payType === 'common') {
				this.payUrl = '/static/images/company_wechat.png'
				return 
			}	
			getPayUrl({ type: 0, goodsId: this.material.id, payType, empowerType: this.activeTab })
				.then(res => {
					this.payUrl = res.data.data;
					this.getPayResult(res.data.orderId);
				})
				.catch(() => {
					this.payUrl = "";
				});
		},
		getPayResult(id) {
			const paidName = this.activeTab === 0 ? 'paid' : (this.activeTab === 1 ? 'enterprisePaid' : 'enterprisePlusPaid')
			getStatus(id).then(res => {
				const { data } = res;
				if (data.code === 1) {
					this.payUrl = "";
					this.material[paidName] = true;
					this.showPayWay = false
					this.getDetail()
				} else if (data.code === 2) {
					setTimeout(() => {
						this.getPayResult(id);
					}, 2e3);
				} else if (data.code === 3) {
					this.payUrl = "";
					this.material[paidName] = true;
					this.showPayWay = false
					this.getDetail()
				} else {
					this.payUrl = "";
					this.showPayWay = false
					this.$message.error("付款失败，" + data.msg);
				}
			});
		},
		
		setMaterial(material) {
			if (!material.id) {
				return;
			}
			openWindow(`/#/material/detail/${material.id}`)
		},
		toAuthor(authorName) {
			if (!authorName) {
				return;
			}
			openWindow(`/#/material/author/${authorName}`)
		}
	},
};
</script>

<style lang="scss" scoped>
.material {
	width: 100%;
	min-height: 100%;
	overflow-y: auto;
	position: relative;
	.material-title {
		width: 1285px;
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: 20px;
			color: #000000;
			padding: 40px 0 24px;
			margin: 0 auto;
			.material-exclusive {
				margin-left: 16px;
				padding: 2px 10px;
				border-radius: 4px 4px 4px 4px;
				border: 1px solid #000000;
				font-weight: 400;
				font-size: 12px;
				color: #000000;
				cursor: pointer;
			}
		}
	.material-detail {
		width: 100%;
		min-height: 100%;
		overflow-y: auto;
		display: flex;
		justify-content: center;
		position: relative;

	}
	.bottom {
		width: 1285px;
		margin: 0 auto;
		padding-bottom: 40px;
	}
	.material-content-card {
		border: 0;
	}
	.main-detail {
		// flex: 1;
		// margin:0 20px 0 20px;
		// max-width: 900px;
		width: 880px;
		margin-right: 20px;
		padding: 0;
		border-radius: 10px;
		/deep/ .el-card__body {
			padding: 0;
			.detail-wrap {
				margin: 0 auto;
				border-radius: 10px;
				background-color: #fff;
                // width:820px;
			}
			.detail-head {
				padding: 0 0 10px 0;
				border-bottom: 1px solid #ecedff;
				&__title {
					display: flex;
					justify-content: space-between;
					align-items: center;
					color: #272c40;
					font-size: 22px;
					font-weight: 600;
				}

				&__extra {
					display: flex;
					justify-content: space-between;
					align-items: center;
					.tag {
						margin: 10px 0;
						&-item {
							margin: 10px 10px 0 0;
							padding: 3px 10px;
							background: rgba(47, 84, 235, 0.1);
							border-radius: 12px;
							font-size: 12px;
							color: #2f54eb;
							cursor: pointer;
						}
					}
					.time {
						font-size: 14px;
						color: #a8adc1;
					}
				}
			}
			.detail-content {
				img,
                video {
                    max-width: 100%;
                    max-height: 100%;
                }
				img {
					cursor: url('../../../assets/images/zoom-in-line.png'), auto;
					vertical-align: middle;
					display: block;
					width: 100%;
				}
				p {
					line-height: 0;
					padding:0;
					margin:0;
				}
				.ql-align-center {
					margin: 0;
					padding: 0;
				}
			}
			.mode {
				padding: 3px;
				background: rgba(0, 0, 0, 0.05);
				width: 100px;
				height: 36px;
				span {
					display: inline-block;
					border-radius: 2px;
					width: 50%;
					height: 30px;
					text-align: center;
				}
				.active {
					background-color: #fff;
				}
				img {
					position: relative;
					top: -2px;
					width: 30px;
					vertical-align: bottom;
					cursor: pointer;
				}
			}
		}
	}

	.material-info {
		min-width: 300px;
		// min-height: 650px;
		width: 385px;
		vertical-align: top;
		text-align: left;
		background: inherit;
        // margin-right: 140px;
		overflow: visible;

		& /deep/ .el-card__body {
			text-align: left;
			background: #fff;
			border-radius: 10px;

			.material-info-tab {
				margin-bottom: 20px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				.material-info-tab-item {
					flex: 1;
					margin-right: 3px;
					border-radius: 4px;
					background: #FAFAFA;
					display: flex;
					align-items: center;
					justify-content: center;
					color: #555555;
					font-size: 14px;
					height: 40px;
					cursor: pointer;
					font-weight: 400;
					box-sizing: border-box;
					&:hover {
						background: #E8E8E8;
					}
					&.active {
						// &:nth-child(1) {
							background: #F5F6F9;
							color: #2F54EB;
							border: 1px solid #2F54EB;
						// }
						// &:nth-child(2) {
						// 	background: linear-gradient(-90deg, #2F54EB 0%, #627DE8 100%);;
						// 	color: #F5F6F9;
						// }
						// &:nth-child(3) {
						// 	background: linear-gradient(-90deg, #B68139 0%, #D08D32 98%);
						// 	color: #F5F6F9;
						// }
					}
					&:nth-last-child(1) {
						margin-right: 0;
					}
				}
			}
			.material-info-name {
				font-size: 20px;
				font-weight: 600;
				display: flex;
				.title {
					flex: 1;
				}
				.exclusive {
					margin-right: 6px;
					width: 37px;
					height: 21px;
					background: #EB793C;
					border-radius: 4px 4px 4px 4px;
					line-height: 21px;
					text-align: center;
					color: #fff;
					font-size: 12px;
					position: relative;
					top: 5px;
				}
			}
			.material-info-addition {
				margin-top: 20px;
				display: flex;
				justify-content: space-between;
				&-item {
					display: flex;
					justify-content: space-between;
					align-items: center;
					font-size: 12px;
					&>span {
						display: flex;
						align-items: center;
					}
					.material-info-price-tag {
						&.free {
							color: #3CD19F;
							font-size: 22px;
						}
						&.needPay,
						&.paid {
							padding: 2px 10px;
							border-radius: 4px;
							color: #fff;
							font-weight: 600;
						}
						&.needPay {
							background-color: #eb793c;
							font-weight: 600;
						}
						&.price {
							// margin-left: 10px;
							color: #0C0C0E;
							font-size: 22px;
							font-weight: 600;
							.price-unit {
							font-style: normal;
							color: #0C0C0E;
							font-size: 12px;
							font-weight: 400;
						}
						}
						&.origin-price {
							color: #999;
							font-size: 16px;
							font-weight: 400;
							margin-left: 10px;
							text-decoration-line: line-through;
						}
			
						&.paid {
							border: 1px solid #eb793c;
							color: #eb793c;
							font-weight: 600;
						}
					}
				}
			}

			.material-info-detail-tagInfo {
				margin-top: 11%;
				.el-divider {
					margin: 24px auto;
					background-color: #ccc;
					width: 50%;
					height: 2px;
					border-radius: 3px;

					.el-divider__text {
						padding: 0 10px;
						width: fit-content;
						color: #999;
						font-size: 16px;
					}
				}
			}
			.material-info-detail-payWay {
				margin-bottom: 10px;
				.pay-tit {
					text-align: center;
					color:#272C40;
					font-weight: 600;
					font-size: 20px;
					margin: 40px 0;
				}
				.pay-con {
					display: flex;
					padding: 0 34px;
					justify-content: space-between;
					.pay-item {
						cursor: pointer;
						display: flex;
						width: 130px;
						height: 115px;
						background: #EAFFEA;
						border: 1px solid #09BB07;
						border-radius: 6px;
						justify-content: flex-end;
						align-items: center;
						flex-direction: column;
						padding-bottom: 18px;
						color: #333333;
						font-size: 16px;
						font-weight: 600;
						&:nth-child(2) {
							background: #F7FAFF;
							border: 1px solid #1677FF;
							.pay-icon {
								width: 50px;
								margin-bottom: 9px;
							}
						}
						.pay-icon {
							width: 43px;
							margin-bottom: 16px;
						}
					}
				}
				.pay-tip{
					color:#999999;
					font-size: 12px;
					padding: 0 20px;
					line-height: 20px;
					text-align: center;
					margin-top: 40px;
					position: relative;
					.more-pay-way {
						color: #2c54ef;
						cursor: pointer;
						&:hover {
							color: #5b7dff
						}
					}
				}
			}
		}
		.material-info-detail {
			margin: 3% 0;
			// padding: 2% 5%;
			// background-color: #f9f9f9;
			// border-radius: 6px;
			color: #999999;
			line-height: 2;
			font-size: 14px;

			.detail-info-item {
				display: flex;
				align-items: flex-start;
				justify-content: flex-start;
				label {
					color: #333;
					flex: 1;
				}
				img {
					width: 14px;
					height: 14px;
					margin-right: 5px;
					position: relative;
					top: 7px;
				}

				.author {
					cursor: pointer;
					color:#2c54ef;
					&:hover {
						color: #5b7dff
					}
				}
			}
		}
		.pay-content {
			display: flex;
			align-items: center;
			flex-direction: column;
			.pay-tips {
				margin-top: 50px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #09bb07;
				font-size: 18px;
				img {
					padding-right: 10px;
				}
				&.ali {
					color: #1677FF;
				}
			}
			.material-image {
				width: 200px;
				height: 200px;
			}
			.more-pay-way {
				color: #8C8C8C;
				font-size: 16px;
				cursor: pointer;
				margin-top: 10px;
			}
		}
		.download-btn,
		.pay-btn {
			width: 100%;
			font-size: 20px;
			line-height: 1.5;
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 50px;
			/deep/ span {
				display: flex;
				align-items: center;
				justify-content: center;
			}
			&-img {
				margin-right: 4px;
				width: 26px;
				vertical-align: middle;
			}
		}
		.baidu-code {
			font-size: 14px;
			font-weight: 400;
			color: #272C40;
			margin: 10px 0;
		}
		.local {
			width: 345px;
			height: 54px;
			background: #FFFFFF;
			border-radius: 50px;
			opacity: 1;
			border: 1px solid #27C2FF;
			color: #27C2FF;
			margin-left: 0;
			margin-top: 20px;
			&:hover {
				background: #F0FBFF;
			}
		}
		.download-question {
			color: #aaa;
			font-size: 12px;
			text-align: center;
			margin: 5px 0;
			overflow: visible;
			position: relative;
			span {
				cursor: pointer;
				color: #2F54EB;
				&:hover {
					color: #5B7DFF;
				}
			}
		}
		.ques-text {
			text-align: center;
		}
		.baidu {
			background: #27C2FF;
			border: 0;
			cursor: pointer;
			&:hover {
				background: #5BD1FF;
			}
		}
		.download-btn {
			&.is-disabled {
				font-size: 20px;
			}
		}
		.pay-btn {
			background-color: #2F54EB;
			border-color: #2F54EB;
			&:hover {
				background: #6583FF;
				border-color: #6583FF;
			}
			&.disabled {
				background-color: #d0d0d0;
				border-color: #bababa;
				cursor: inherit;
				&:hover {
					background: #d0d0d0;
				}
			}
		}
		.download-tip {
			display: flex;
			justify-content: space-between;
			margin-top: 10px;
			color: #aaa;
			font-size: 12px;
			/deep/ .el-icon-warning-outline {
				margin-left: 5px;
				transform: rotateX(180deg);
				font-size: 14px;
			}
		}
		.bottom-info {
			font-size: 12px;
			font-weight: 400;
			color: #999999;
			line-height: 17px;
			margin-top: 20px;
		}
		.authorized {
			.authorized-tit {
				display: flex;
				justify-content: space-between;
				align-items: center;
				margin: 20px 0;
				font-weight: 400;
				color: #555555;
				line-height: 20px;
				font-size: 14px;
				position: relative;
				// span {
				// 	margin-left: 20px;
				// }
				.authorized-active {
					cursor: pointer;
					color:#2c54ef;
					&:hover {
						color: #5b7dff
					}
				}
				.authorized-active-default {
					cursor: pointer;
					color:#A8ADC1;
					margin-right: 15px;
					&:nth-last-child(1) {
						margin-right: 0;
					}
					&:hover {
						color: #2F54EB
					}
				}
			}
			.authorized-item {
				border-radius: 2px 2px 2px 2px;
				display: flex;
				align-items: flex-start;
				justify-content: flex-start;
				padding: 15px;
				font-weight: 400;
				color: #555555;
				line-height: 20px;
				font-size: 14px;
				overflow: hidden;
				&:nth-child(even) {
					background: #FAFAFA;
				}
				.authorized-item-text {
					flex: 1;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				img {
					width: 14px;
					height: 14px;
					margin-right: 8px;
					position: relative;
					top: 3px
				}
			}
		}
		.service-modal {
			position: absolute;
			left: -100px;
			cursor: default;
			top: 30px;
			width: 470px;
			height: 180px;
			background: #fff;
			box-shadow: 0px 4px 20px 1px rgba(0, 0, 0, 0.302);
			border-radius: 4px 4px 4px 4px;
			padding: 15px 20px;
			overflow: hidden;
			display: flex;
			z-index: 100;
			img {
				width: 150px;
				height: 150px;
				border-radius: 2px;
				margin-right: 15px;
			}
			& > div {
				flex: 1;
				// overflow: hidden;
				height: 150px;
				margin-top: 3px;
			}
			&-tit {
				color: #252525;
				font-size: 20px;
				font-weight: 600;
				text-align: left;
				margin-bottom: 12px;
			}
			&-info {
				color: #8c8c8c;
				font-size: 18px;
				line-height: 26px;
				white-space: normal;
				text-align: left;
			}
		}
	}
	.bottom-tit {
		font-size: 18px;
		font-weight: 600;
		color: #272C40;
		line-height: 26px;
		margin-top: 20px;
	}
	.material-list {
		&-item {
			display: inline-block;
			margin-right: 20px;
			margin-top: 20px;
			width: 300px;
		}
	}
}
.pay-modal {
	position: fixed;
	z-index: 10;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	background: rgba($color: #000000, $alpha: 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	.pay-modal-con {
		background: #fff;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		flex-direction: column;
		position: relative;
		.modal-tit {
			font-weight: 400;
			font-size: 20px;
			color: #272C40;
			margin: 20px 0 15px 0;
			text-align: center;
		}
		.modal-close {
			position: absolute;
			right: -60px;
			top: -25px;
			width: 50px;
			height: 50px;
			cursor: pointer;
		}
		.pay-con {
			padding: 0 59px 50px 59px;
			display: flex;
			.pay-icon {
				width: 130px;
				height: 115px;
				background: #F7FFF7;
				border-radius: 6px 6px 6px 6px;
				border: 1px solid #09BB07;
				margin-right: 24px;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
				cursor: pointer;
				&:hover {
					background: #DEFFDE;
				}
				&.alipay {
					background: #F7FAFF;
					border-color: #1677FF;
					&:hover {
						background: #E3EDFF;
					}
				}
				&.common {
					background: #FFF7F7;
					border-color: #FA5151;
					&:hover {
						background: #FFE0E0;
					}
				}
				img {
					width: 43px;
					margin-bottom: 16px;
				}
				&:nth-last-child(1) {
					margin-right:0;
				}
			}
		}
		.pay-qr {
			box-sizing: content-box;
			width: 200px;
			padding: 0 50px 30px 50px;
			img {
				width: 200px;
			}
		}
	}
}
.ques {
	position: relative;
	overflow: hidden;
	display: flex;
	align-items: center;
	background: #fff;
	padding: 0 20px 20px 20px;
	border-radius: 4px;
	img {
		float: left;
		margin-right: 10px;
		width: 60px;
	}
	&-tip {
		color: #666;
	}
	&-text {
		font-size: 12px;
		color: #999;
	}
	&-desc {
		flex:1;
	}
}
.ques-other {
	margin-top: 10px;
	border-radius: 4px;
	padding: 20px;
}
.share {
	color: #758ef7;

	&-img {
		margin-right: 5px;
		vertical-align: top;
	}
}
.collected-con {
	color: #ed709b;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}
.collect-con{
	color: #999;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}
.icon-collect-btn {
	color: #999;
	cursor: pointer;
}
.collected {
	color: #ed709b;
	padding: 6px;
	cursor: pointer;
}
</style>
